import React from "react";

import { oops } from "../assets/mensagens";

const Oops = ({ tem_texto, texto }) => {
    return (
        <div className="oops">
            <div className="container-img">
                <img src={oops} alt="Imagem" />
            </div>
            {tem_texto ? <span>{texto}</span> : <span>Não existem dados!</span>}
        </div>
    );
};

export default Oops;
